import { memo } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

function FundingCloseReasonForm({ fundingCloseReason }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Close Reason:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="closeReason"
          id="closeReason"
          value={fundingCloseReason || ''}
          readOnly
        />
      </Col>
    </>
  );
}
export default memo(FundingCloseReasonForm);
